export default __webpack_public_path__ + "static/media/avatar_koala4.cd037609.mp3";